import React, { useContext } from 'react';
// Hooks

// Context
import { FormDataContext } from 'globalState/FormDataContext';
// Components
import Table from 'components/shared/Table/Table';
import ConsentForm from './StepConsentForm';

function StepSummarySection() {
  const [formDataState, formDataDispatch] = useContext(FormDataContext);
  const {
    firstName,
    lastName,
    Company,
    emailAddress,
    ContactPhone,
    Phone,
    EventName,
    DateOfEvent,
    Address,
    AddressPostcode,
    EventDescription,
  } = formDataState.formData;

  const setStepInContext = (st) => {
    formDataDispatch({
      type: 'UPDATE_STEP',
      payload: st,
    });
  };

  const title = 'Check your answers';

  /* Table Data */

  // name
  const dataLine1 = [];
  dataLine1.push(<span>Name</span>);
  dataLine1.push(<span>{`${firstName} ${lastName}`}</span>);
  dataLine1.push(
    <button
      type="button"
      className="wmcads-btn wmcads-btn--link"
      onClick={() => {
        setStepInContext(4);
      }}
    >
      Change
    </button>
  );

  // contact information
  const dataLine2 = [];
  dataLine2.push(<span>How would you like to be contacted?</span>);
  if (emailAddress !== null && ContactPhone === '') {
    dataLine2.push(
      <span>
        Email
        <br /> {emailAddress}
      </span>
    );
  } else if (emailAddress === '' && ContactPhone) {
    dataLine2.push(
      <span>
        Phone
        <br /> {ContactPhone}
      </span>
    );
  } else if (emailAddress && ContactPhone) {
    dataLine2.push(
      <div>
        <span>
          Email
          <br /> {emailAddress}
        </span>
        <br />
        <br />
        <span>
          Phone
          <br /> {ContactPhone}
        </span>
      </div>
    );
  }

  dataLine2.push(
    <button
      type="button"
      className="wmcads-btn wmcads-btn--link"
      onClick={() => {
        setStepInContext(5);
      }}
    >
      Change
    </button>
  );

  const dataLine3 = [];
  dataLine3.push(<span>Company</span>);
  dataLine3.push(<span>{Company}</span>);
  dataLine3.push(
    <button
      type="button"
      className="wmcads-btn wmcads-btn--link"
      onClick={() => {
        setStepInContext(5);
      }}
    >
      Change
    </button>
  );

  const dataLine4 = [];
  dataLine4.push(<span>Event Name</span>);
  dataLine4.push(<span>{EventName}</span>);
  dataLine4.push(
    <button
      type="button"
      className="wmcads-btn wmcads-btn--link"
      onClick={() => {
        setStepInContext(3);
      }}
    >
      Change
    </button>
  );

  const dataLine5 = [];
  dataLine5.push(<span>Date</span>);
  dataLine5.push(<span>{DateOfEvent}</span>);
  dataLine5.push(
    <button
      type="button"
      className="wmcads-btn wmcads-btn--link"
      onClick={() => {
        setStepInContext(3);
      }}
    >
      Change
    </button>
  );

  const dataLine6 = [];
  dataLine6.push(<span>Location</span>);
  dataLine6.push(<span>{Address}</span>);
  dataLine6.push(
    <button
      type="button"
      className="wmcads-btn wmcads-btn--link"
      onClick={() => {
        setStepInContext(3);
      }}
    >
      Change
    </button>
  );

  const dataLine7 = [];
  dataLine7.push(<span>Postcode</span>);
  dataLine7.push(<span>{AddressPostcode}</span>);
  dataLine7.push(
    <button
      type="button"
      className="wmcads-btn wmcads-btn--link"
      onClick={() => {
        setStepInContext(3);
      }}
    >
      Change
    </button>
  );

  const dataLine8 = [];
  dataLine8.push(<span>Description</span>);
  dataLine8.push(<span>{EventDescription}</span>);
  dataLine8.push(
    <button
      type="button"
      className="wmcads-btn wmcads-btn--link"
      onClick={() => {
        setStepInContext(3);
      }}
    >
      Change
    </button>
  );

  /* End of Table Data */

  const data = [dataLine1, dataLine2, dataLine3];
  const eventData = [dataLine4, dataLine5, dataLine6, dataLine7, dataLine8];

  if (Phone) {
    data.push(dataLine2);
  }

  return (
    <>
      <div className="wmcads-col-1">
        <h2 className="wmcads-fe-question wmcads-m-t-none">{title}</h2>
        <Table
          title="About you"
          classes=""
          cellClasses={['', '', 'wmcads-text-align-right wmcads-p-r-none']}
          headers={[]}
          values={data}
          data-private
        />

        <Table
          title="Event Information"
          classes=""
          cellClasses={['', '', 'wmcads-text-align-right wmcads-p-r-none']}
          headers={[]}
          values={eventData}
          data-private
        />

        <h3>Now send your enquiry</h3>
        <p>
          By submitting this enquiry you are confirming that, to the best of your knowledge, the
          details you are providing are correct.
        </p>
        <ConsentForm />
      </div>
    </>
  );
}

export default StepSummarySection;
